// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"68eb98fe","453":"dba54fb1"}[chunkId] + ".chunk.js";
};